package pages

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.dom.*
import shared.content.LegalPagesContent

@Composable
fun PrivacyPage() {
    val page = LegalPagesContent.privacyPage
    LegalPageLayout(title = page.title) {
        P(attrs = { classes("legal-meta") }) { Text("Last updated: ${page.lastUpdated}") }
        page.sections.forEach { section ->
            LegalSectionView(section)
        }
    }
}
